import axios from '../../plugins/axios';

export const editServiceState = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/service/${data.serviceId}/state/${data.id}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const createServiceState = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post(`/api/service/${data.serviceId}/state`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const deleteServiceState = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.delete(`/api/service/${data.serviceId}/state/${data.id}`, config)
    .then((response) => response )
    .catch((error) => error.response );
};